// extracted by mini-css-extract-plugin
export default {"page_container":"History_page_container__K3Odz"};